// extracted by mini-css-extract-plugin
export default {"icon":"Links_icon__3pzPF","linkText":"Links_linkText__BRkBS"};